import { optionSelectCombinedAutoAndManualCheckpoints } from './manual-vitals'
import { optionSelectIndividualVitalTypes } from './vital-type'

/**
 * @param {CaseData} caseData
 * @param {{
 *   maxDuration: number
 *   tempUnit: TempUnit
 *   appTime: number
 *   timeFormatFn?: (time: number) => string
 * }} opts
 * @returns {string[][]}
 */
export const optionSelectVitalsDataReference = (
  caseData,
  { maxDuration, tempUnit, appTime, timeFormatFn }
) => {
  const checkpoints = optionSelectCombinedAutoAndManualCheckpoints(caseData, {
    appTime,
    tempUnit,
    maxDuration,
  })
  const vitalTypesById = optionSelectIndividualVitalTypes(caseData, {
    tempUnit,
  }).reduce((acc, vt) => {
    acc[vt.id] = vt
    return acc
  }, {})

  const vitalsObj = {}
  for (const cp of checkpoints) {
    for (const vital of cp.vitalsInUse) {
      vitalsObj[vital.id] = true
    }
  }
  const vitalTypes = Object.keys(vitalsObj)
  const rows = [
    ['Time', ...vitalTypes.map(type => vitalTypesById[type].chartName)],
  ]

  for (const cp of checkpoints) {
    const values = cp.values || {}
    // We get a placeholder checkpoint before the case
    // has started that does not have a time
    // We don't want to try to render this.
    if (cp.time) {
      rows.push([
        timeFormatFn ? timeFormatFn(cp.time) : cp.time,
        ...vitalTypes.map(type => {
          const found = values[type]
          const value = found && found.value != null ? found.value : null
          return value === 'skipped' ? null : value
        }),
      ])
    }
  }
  return rows
}
